import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a73bd4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-box" }
const _hoisted_2 = { class: "text" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonHomeComponent',
  props: {
  icon: { type: String, default: '' },
  text: { type: String, default: '' },
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1)
  ]))
}
}

})